import { Activity, Merchant, Device } from './types';

export const formatTimeAgo = (date: Date): string => {
  const now = new Date();
  const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));

  if (diffInMinutes < 1) return 'Just now';
  if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;

  const diffInDays = Math.floor(diffInHours / 24);
  return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
};

export const generateActivitiesFromData = (
  merchants: Merchant[],
  devices: Device[]
): Activity[] => {
  const activities: Activity[] = [];
  const now = new Date();

  if (merchants.length > 0) {
    const recentMerchant = merchants[0];
    const merchantName = recentMerchant.name || recentMerchant.business_name || 'Unknown Merchant';
    activities.push({
      id: 1,
      action: `Merchant "${merchantName}" registered`,
      time: formatTimeAgo(new Date(now.getTime() - 2 * 60 * 1000)),
      status: 'success',
      type: 'merchant',
      iconKey: 'merchant',
    });
  }

  if (devices.length > 0) {
    const recentDevice = devices[0];
    const deviceName = recentDevice.name || recentDevice.identifier || 'Unknown Device';
    activities.push({
      id: 2,
      action: `Device "${deviceName}" connected`,
      time: formatTimeAgo(new Date(now.getTime() - 5 * 60 * 1000)),
      status: 'success',
      type: 'device',
      iconKey: 'device',
    });
  }

  activities.push(
    {
      id: 3,
      action: 'System maintenance completed',
      time: formatTimeAgo(new Date(now.getTime() - 10 * 60 * 1000)),
      status: 'info',
      type: 'system',
      iconKey: 'system',
    },
    {
      id: 4,
      action: 'Database backup completed',
      time: formatTimeAgo(new Date(now.getTime() - 30 * 60 * 1000)),
      status: 'success',
      type: 'system',
      iconKey: 'system',
    }
  );

  return activities;
};

export const getStatusColor = (status: string): string => {
  switch (status) {
    case 'success': return '#48BB78';
    case 'warning': return '#ED8936';
    case 'error': return '#E53E3E';
    case 'info': return '#2D6CCA';
    default: return '#2D6CCA';
  }
};
